import { useState, type InputHTMLAttributes } from "react";

import { Button } from "./Button";
import { FormField } from "./FormField";

interface PasswordFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  label: string;
  error?: string | undefined;
  showStrength?: boolean | undefined;
}

export function PasswordField({ label, error, showStrength = false, value, ...props }: PasswordFieldProps) {
  const [visible, setVisible] = useState(false);
  const length = typeof value === "string" ? value.length : 0;
  const strength = length === 0 ? "未輸入" : length < 6 ? "弱" : length < 10 ? "中" : "強";
  return (
    <div>
      <FormField {...props} value={value} label={label} error={error ?? ""} type={visible ? "text" : "password"} />
      <Button type="button" variant="link" onClick={() => setVisible((current) => !current)} aria-pressed={visible}>
        {visible ? "隱藏密碼" : "顯示密碼"}
      </Button>
      {showStrength && <p className="small text-muted" aria-live="polite">密碼強度：{strength}</p>}
    </div>
  );
}
